// Contenido de muestra para el carrusel del panel derecho del login.
// Placeholder — la distribución final de automatizaciones por módulo
// está pendiente de confirmación con negocio (ver design_handoff_sustemia_login/README.md).
const modulesByLang = {
  es: [
    { pillar: "AMBIENTAL", title: "Energía", desc: "kWh → tCO₂e automático" },
    { pillar: "AMBIENTAL", title: "Agua", desc: "Consumo e intensidad" },
    { pillar: "AMBIENTAL", title: "Efluentes", desc: "Parámetros y límites" },
    { pillar: "AMBIENTAL", title: "GEI", desc: "Alcances 1, 2 y 3" },
    { pillar: "AMBIENTAL", title: "Residuos", desc: "% reciclado y desviado" },
    { pillar: "SEGURIDAD", title: "Plan Anual", desc: "Avance en vivo" },
    { pillar: "SEGURIDAD", title: "Matriz Legal", desc: "Alertas de vencimiento" },
    { pillar: "SEGURIDAD", title: "Accidentes", desc: "Causa raíz digital" },
    { pillar: "SEGURIDAD", title: "Permisos", desc: "Aprobaciones digitales" },
    { pillar: "SOCIAL", title: "Debida Diligencia", desc: "Proceso completo" },
    { pillar: "SOCIAL", title: "Riesgos Sociales", desc: "Matriz de riesgo" },
    { pillar: "SOCIAL", title: "Políticas", desc: "Gestor y brechas" },
  ],
  en: [
    { pillar: "ENVIRONMENTAL", title: "Energy", desc: "kWh → tCO₂e automatically" },
    { pillar: "ENVIRONMENTAL", title: "Water", desc: "Consumption and intensity" },
    { pillar: "ENVIRONMENTAL", title: "Effluents", desc: "Parameters and limits" },
    { pillar: "ENVIRONMENTAL", title: "GHG", desc: "Scopes 1, 2 and 3" },
    { pillar: "ENVIRONMENTAL", title: "Waste", desc: "% recycled and diverted" },
    { pillar: "SAFETY", title: "Annual Plan", desc: "Live progress" },
    { pillar: "SAFETY", title: "Legal Matrix", desc: "Deadline alerts" },
    { pillar: "SAFETY", title: "Accidents", desc: "Digital root cause" },
    { pillar: "SAFETY", title: "Permits", desc: "Digital approvals" },
    { pillar: "SOCIAL", title: "Due Diligence", desc: "Full process" },
    { pillar: "SOCIAL", title: "Social Risks", desc: "Risk matrix" },
    { pillar: "SOCIAL", title: "Policies", desc: "Manager and gaps" },
  ],
  pt: [
    { pillar: "AMBIENTAL", title: "Energia", desc: "kWh → tCO₂e automático" },
    { pillar: "AMBIENTAL", title: "Água", desc: "Consumo e intensidade" },
    { pillar: "AMBIENTAL", title: "Efluentes", desc: "Parâmetros e limites" },
    { pillar: "AMBIENTAL", title: "GEE", desc: "Escopos 1, 2 e 3" },
    { pillar: "AMBIENTAL", title: "Resíduos", desc: "% reciclado e desviado" },
    { pillar: "SEGURANÇA", title: "Plano Anual", desc: "Progresso em tempo real" },
    { pillar: "SEGURANÇA", title: "Matriz Legal", desc: "Alertas de vencimento" },
    { pillar: "SEGURANÇA", title: "Acidentes", desc: "Causa raiz digital" },
    { pillar: "SEGURANÇA", title: "Permissões", desc: "Aprovações digitais" },
    { pillar: "SOCIAL", title: "Diligência Devida", desc: "Processo completo" },
    { pillar: "SOCIAL", title: "Riscos Sociais", desc: "Matriz de risco" },
    { pillar: "SOCIAL", title: "Políticas", desc: "Gestor e lacunas" },
  ],
};

export function getEcosystemModules(language) {
  return modulesByLang[language] || modulesByLang.es;
}
